import { isTruthy } from "@suse-o11y/is-truthy";
import type { JSON } from "@suse-o11y/json";
import { Signal } from "@suse-o11y/signal";
import { toJSON } from "@suse-o11y/to-json";
import { usePermanent } from "@suse-o11y/use-permanent";
import React from "react";

import { ToggleListRootContextProvider } from "./_toggle-list-root-context";

export interface ToggleListRootProps {
	namespace?: JSON;
}

export const ToggleListRoot: React.FC<React.PropsWithChildren<ToggleListRootProps>> = ({ namespace, children }) => {
	const uniqId = React.useId();
	const rootNamespace = namespace == null ? uniqId : toJSON(namespace);
	const listNamespace = usePermanent(() => Signal(""));

	const compositeNamespace = React.useMemo(
		() =>
			Signal<string>(
				(monitor) => [rootNamespace, listNamespace.read(monitor)].filter(isTruthy).join("|"),
				listNamespace,
			),
		[rootNamespace, listNamespace],
	);

	return <ToggleListRootContextProvider value={compositeNamespace}>{children}</ToggleListRootContextProvider>;
};
